import IMask from 'imask';
import dayjs from 'dayjs';
import { getDateParts } from '@/helpers/dates';

export function formatCurrency(value: number | undefined | null, currency = 'BRL'): string {
  const num = value != null && Number.isFinite(value) ? value : 0;
  return num.toLocaleString('pt-BR', { style: 'currency', currency });
}

export function formatCpf(txt: string): string {
  const mask = IMask.createMask({
    mask: '000.000.000-00',
  });
  mask.resolve(txt);
  return mask.value || txt;
}

export function formatCnpj(txt: string): string {
  const mask = IMask.createMask({
    mask: '00.000.000/0000-00',
  });
  mask.resolve(txt);
  return mask.value || txt;
}

export function cleanDoc(doc: string): string {
  return doc.replace(/\D+/g, '');
}

export function formatDateShort(date: Date): string {
  const { day, month: monthRaw, year } = getDateParts(date);
  const month = monthRaw.substring(0, 3).toLowerCase();

  return `${day}/${month}/${year}`;
}

export function formatDateDto(date: Date): string {
  return dayjs(date).format('YYYY-MM-DD');
}

/** Substitui caracteres de espaço por um NBSP. Útil para evitar quebras no html. */
export function nbsp(txt: string): string {
  return txt.replace(/\s+/g, '\u00A0');
}

/** Dígitos -> (00) 00000-0000. */
export function maskCelular(value: string | null | undefined): string {
  const mask = IMask.createMask({ mask: '(00) 00000-0000' });
  mask.resolve(cleanDoc(value ?? ''));
  return mask.value;
}

export default {
  currency: formatCurrency,
  cpf: formatCpf,
  cnpj: formatCnpj,
  dateShort: formatDateShort,
  dateDto: formatDateDto,
  cleanDoc,
  nbsp,
  maskCelular,
};
